
export const apiRoutes = {
    GET_LIST_WALLET: '/api/wallets', //GET auth bearer
    GET_LIST_TOKEN: '/api/wallets/{walletId}/balance/tokens',
    GET_TOKEN_BALANCE: '/api/wallets/{walletId}/balance/tokens/{tokenAddress}',


}